import React, {useEffect, useState} from 'react'
import {Grid, FormControl, InputLabel, TextField, FormHelperText} from '@material-ui/core'
import {DateTimePicker} from '@material-ui/pickers'
import moment from 'moment'

export default function WDateTimeField({data, onChange, itemSelected, tabActive}) {
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    if (data.description === 'reservation_start') {
      onChange(
        null,
        data.key,
        moment(itemSelected.start_date)
          .local()
          .format('YYYY-MM-DD HH:mm:ss')
      )
      setDisabled(true)
    } else if (data.description === 'reservation_end') {
      onChange(
        null,
        data.key,
        moment(itemSelected.end_date)
          .local()
          .format('YYYY-MM-DD HH:mm:ss')
      )
      setDisabled(true)
    } else if (data.description === 'reservation_return') {
      onChange(
        null,
        data.key,
        moment()
          .local()
          .format('YYYY-MM-DD HH:mm:ss')
      )
      setDisabled(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemSelected, data])

  useEffect(() => {
    if (data.value) {
      onChange(null, data.key, data.value)
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Grid item xs={6}>
      <FormControl fullWidth variant="outlined" className="ap-textfield" style={{width: 320}}>
        <DateTimePicker
          label={data.name}
          inputVariant="outlined"
          value={
            data.value ||
            moment()
              .local()
              .format('YYYY-MM-DD HH:mm:ss')
          }
          onChange={e => {
            onChange(
              e,
              data.key,
              moment(e)
                .local()
                .format('YYYY-MM-DD HH:mm:ss')
            )
          }}
          disabled={disabled}
        />
        <FormHelperText>
          {(() => {
            if (
              (tabActive === 'upcoming' && data.is_required) ||
              (tabActive === 'ongoing' && data.is_required_return)
            ) {
              return 'required*'
            } else {
              return 'optional'
            }
          })()}
        </FormHelperText>
      </FormControl>
    </Grid>
  )
}
